/**
 * Created by prog2 on 26/10/2018.
 */
export default {
    VISIT_TYPE_LISTEN: 'listen',
    VISIT_TYPE_READ: 'read',
    URL_AUDIO: 'https://catedraldevalencia.tramamedia.com/audios/',
    // PATH_AUDIO: cordova.file.dataDirectory + '/' + 'audio_' + this.$i18n.locale + '/' + this.$i18n.locale + '/'

}



// WEBPACK FOOTER //
// ./src/constants.js